import { createLogger } from "browser-bunyan";
type Logger = ReturnType<typeof createLogger>;

const url = process.env.REACT_APP_API_BYGGDATA_BASE_URL + "api/client";

export interface IResourceData {
    displayName: string
}

export interface IClientData {
    allowAccessTokensViaBrowser: boolean,
    allowedGrantTypes: string[],
    allowedScopes: string[],
    clientName: string,
    postLogoutRedirectUris: string[]
    redirectUris: string[]
}

export interface IConfigurationData {
    resources: { [id: string]: IResourceData },
    clients: { [id: string]: IClientData }
}

export default class Client {
    private fetch: ((input: string, init?: RequestInit) => Promise<Response>);
    private log?: Logger;

    constructor(
        f: ((input: string, init?: RequestInit) => Promise<Response>),
        l?: Logger
    ) {
        this.fetch = f;
        this.log = l;
    }

    public GetAll = () => this.fetch(url)
        .then(r => r.json() as Promise<IConfigurationData>)
        .catch(r => {
            if (this.log) {
                this.log.error(r);
            }
        });;
}


// WEBPACK FOOTER //
// ./src/data/client.ts